import { cva } from '@/styled-system/css';

export const zillowLogoRecipe = cva({
  base: {
    'maxWidth': '100%',
    'height': '100%',
    'display': 'block',
    'color': 'ZillowLogo.brand-text',
    '& .c11n-logo-mark': {
      fill: 'ZillowLogo.brand-mark',
    },
  },
  variants: {
    onImpact: {
      true: {
        'color': 'ZillowLogo.onImpact.brand-text',
        '& .c11n-logo-mark': {
          fill: 'ZillowLogo.onImpact.brand-mark',
        },
      },
      false: {},
    },
    showLegacyLogo: {
      true: {
        'color': 'ZillowLogo.legacy.brand-text',
        '& .c11n-logo-mark': {
          fill: 'ZillowLogo.legacy.brand-mark',
        },
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      onImpact: true,
      showLegacyLogo: true,
      css: {
        'color': 'ZillowLogo.legacy.onImpact.brand-text',
        '& .c11n-logo-mark': {
          fill: 'ZillowLogo.legacy.onImpact.brand-mark',
        },
      },
    },
  ],
});
